import { render } from "./StockSync.vue?vue&type=template&id=7bf5b7b6"
import script from "./StockSync.vue?vue&type=script&lang=js"
export * from "./StockSync.vue?vue&type=script&lang=js"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__